import type { ScheduleResponse } from '@/Network/Types/Responses/ScheduleUnitResponses'

/**
 * Shape esperado pelo prop `scheduleDetails` de
 * `@/components/designSystem/modals/EditScheduleModal/index.vue`.
 */
export interface ScheduleDetails {
  id: number
  name: string
  healthUnitName: string
  companyName: string
  companyId: number
  endDate: string | null
}

/**
 * Monta o `scheduleDetails` do deep-link do Pós-Plantão a partir da resposta
 * de `Network.schedule.getById()`. O backend já devolve `healthUnit.company`
 * (minhaescala-backend#2329); o `null` aqui é cinto de segurança contra
 * backends antigos/cache sem essa relação — nunca usar `?? 0` para companyId.
 */
export function buildScheduleDetails(schedule: ScheduleResponse): ScheduleDetails | null {
  const companyId = schedule.healthUnit.company?.id
  if (!companyId) return null

  return {
    id: schedule.id,
    name: schedule.name,
    healthUnitName: schedule.healthUnit.name,
    companyName: schedule.healthUnit.company?.name ?? '',
    companyId,
    endDate: schedule.endDate
  }
}
